import type { JobAdsFetch } from "@/modules/jobAds/client/hooks/useJobAdsFetch"

import { useContext } from "react"

import { JobAdsFetchContext } from "@/modules/jobAds/client/components/JobAdsFetchProvider/JobAdsFetchProvider"

export const useJobAdsFetchContext = (): JobAdsFetch => {
  const context = useContext(JobAdsFetchContext)

  if (!context) {
    throw new Error(`Missing job ads fetch context when fetching job ads data.`)
  }

  return context.jobAdsFetchHook()
}
